import axios from "axios";

export default async function useGetDocumentTypeBySession(session: string) {
    try {
        const response = await axios.post(
            process.env.REACT_APP_GET_DOCUMENT_TYPE_ENDPOINT || "",
            { session }
        );

        if (response.status >= 200 && response.status < 300) {
            return response.data.response.doc_type;
        } else {
            console.error("Invalid session", response);
            
            throw new Error("Invalid session")
        }
    } catch (error) {
        console.error(error);
        throw new Error("Invalid session")
    }
}
